import { IActionButton, ICandidateApplyFailure } from "@core/models";

export const candidateApplyFailureMock1 = {
  [ICandidateApplyFailure.type]: "warning", // "warning"|"error"|"info"
  [ICandidateApplyFailure.message]: "Lorem ipsum dolor si amet",
  [ICandidateApplyFailure.title]: "La candidature n'a pas aboutie",
  [ICandidateApplyFailure.actions]: [
    {
      [IActionButton.label]: "Mes dispos",
      [IActionButton.link]: "#/mon-espace/profil/mes-disponibilites",
    },
  ],
};

export const candidateApplyFailureMock2 = {
  [ICandidateApplyFailure.type]: "error",
  [ICandidateApplyFailure.message]: "Lorem ipsum dolor si amet",
  [ICandidateApplyFailure.title]: "Erreur lors de la candidature",
  [ICandidateApplyFailure.actions]: [
    {
      [IActionButton.label]: "Voir les disponibilités",
      [IActionButton.link]: "#/mon-espace/profil/mes-disponibilites",
    },
  ],
};
